import React from 'react';
type SectionHeadingProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'center' | 'left';
  id?: string;
};
export function SectionHeading({
  title,
  subtitle,
  align = 'center',
  id
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'mx-auto text-center' : 'text-left';
  return <div className={`max-w-2xl ${alignment}`} data-id="element-204" data-mp="hq8muwddte47">
      <h2 id={id} className="font-serif text-[2.1rem] leading-[1.08] text-ink md:text-5xl" data-id="element-205" data-mp="ht4j8g9kzuqj">
        {title}
      </h2>
      {subtitle && <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-206" data-mp="8r3pvuhgxsu5">{subtitle}</p>}
    </div>;
}